// src/pages/Favorites.jsx
import React from 'react';
import styled from 'styled-components';
import ListingCard from '../components/ListingCard';
import { useFavoritesStore } from '../store/useFavoritesStore';
import { useTranslation } from 'react-i18next';
import { useCurrencyStore } from '../store/useCurrencyStore';
import { PublicAPI } from '../api/public';

const Grid = styled.div`
  display:grid; gap:14px; grid-template-columns:1fr 1fr;
  @media(max-width:720px){grid-template-columns:1fr}
`;

export default function Favorites(){
  const favIds = useFavoritesStore(s=>s.favorites);
  const clear = useFavoritesStore(s=>s.clearFavorites);
  const [items, setItems] = React.useState([]);
  const [err, setErr] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const { i18n } = useTranslation();
  const currencyCode = useCurrencyStore(s => s.code) || 'AED';

  React.useEffect(()=>{
    let cancelled = false;
    async function load(){
      setLoading(true); setErr('');
      try{
        if (!favIds.length){ setItems([]); return; }
        const tasks = favIds.map(id =>
          PublicAPI.propertyBySlug(String(id), { locale: i18n.language || 'ru', currency: currencyCode })
            .then(r => r?.property || r || null)
            .catch(()=> null)
        );
        const res = await Promise.all(tasks);
        const list = res.filter(Boolean);
        if(!cancelled) setItems(list);
      }catch(e){ if(!cancelled) setErr(e.message || 'Error'); }
      finally{ if(!cancelled) setLoading(false); }
    }
    load(); return ()=>{ cancelled = true; };
  }, [favIds, i18n.language, currencyCode]);

  return (
    <main className="container" style={{padding:'16px 0'}}>
      <h2>Избранное</h2>
      {err && <div style={{color:'#c62828', marginBottom:8}}>{err}</div>}
      {loading && <div style={{opacity:.7}}>Загрузка…</div>}
      {!loading && !favIds.length && <p>Пока пусто. Нажимайте на сердечки на карточках объектов.</p>}
      {!!items.length && (
        <>
          <div style={{margin:'8px 0 14px', display:'flex', gap:8}}>
            <button className="btn" onClick={clear}>Очистить избранное</button>
          </div>
          <Grid>{items.map(i => <ListingCard key={i.id ?? i.slug} item={i}/>)}</Grid>
        </>
      )}
    </main>
  );
}
